export default {
  title: 'コードバッチを選択',
};
